import type {ReactElement} from 'react';
import type {RowDefinition} from '@Libraries/timeline/types';
import {useRow} from '@Libraries/timeline';
import React from 'react';
import {TimelineItemTypeId} from '@Components/poster-editor/components/poster-editor-web-bottom-bar/poster-editor-web-bottom-bar.helper';

interface RowProps extends RowDefinition {
  children: React.ReactNode;
}

const POSTER_ITEM_ROW_HEIGHT = 48;
const NON_POSTER_ITEMS_ROW_HEIGHT = 36;
const GAP_BETWEEN_ROWS = 8;

export function BaseTimelineRow({...props}: RowProps): ReactElement<any> {
  const {setNodeRef, rowWrapperStyle, rowStyle} = useRow({id: props.id});

  return (
    <div
      id={props.id}
      key={props.id}
      style={{...rowWrapperStyle, paddingBottom: '2px', minHeight: props.id === `${TimelineItemTypeId.Design}` ? POSTER_ITEM_ROW_HEIGHT : NON_POSTER_ITEMS_ROW_HEIGHT}}
    >
      <div ref={setNodeRef} style={{...rowStyle, gap: GAP_BETWEEN_ROWS}}>
        {props.children}
      </div>
    </div>
  );
}
